module.exports = __webpack_public_path__ + "media/images/hamburger-a0147916054f0978733395174e92df06.svg";